import { useMessagesLoaded, } from '@/assets/js/src/modules/lang/_composables/useMessagesLoaded'
import { useTranslation, } from '@/assets/js/src/util/composables/useTranslation'
import { computed, } from 'vue'
import { genHeadOverrides, } from '@/assets/js/src/layout/meta'
import { useHead, } from '@unhead/vue'

export const useListHeadInfo = () => {
    const { messagesLoaded, } = useMessagesLoaded([ 'help', ])
    const { t, } = useTranslation()

    const title = computed(() => {
        return messagesLoaded.value
            ? t('async.help.heading')
            : 'Help'
    })
    
    const description = computed(() => {
        return messagesLoaded.value
            ? t('async.help.description')
            : ''
    })

    useHead(genHeadOverrides({ title, description, }))

    return {
        description,
    }
}
